export default __webpack_public_path__ + "static/media/015-snow.bf31e076.svg";